import type React from 'react'
import bgVector from '../../assets/figma/116-3974/5dd07467e03e93c25199c9cd58f7b0799f0cf229.svg'
import questionSvg from '../../assets/figma/116-4012/1dfba4bd6725541b877e703069c36cc10df8365e.svg'
import backSvg from '../../assets/figma/116-4012/6395b82a744124e628e5745d821d17d45ba3f9a1.svg'

type HeaderIcon = 'Back' | 'Question' | null

const IconImg: React.FC<{ name: Exclude<HeaderIcon, null> }> = ({ name }) => {
  if (name === 'Question') {
    return (
      <img src={questionSvg} alt="" aria-hidden="true" className="block size-full max-w-none" />
    )
  }
  return <img src={backSvg} alt="" aria-hidden="true" className="block size-full max-w-none" />
}

const IconButton: React.FC<{
  icon: HeaderIcon
  onClick?: () => void
  ariaLabelBack?: string
  ariaLabelQuestion?: string
}> = ({ icon, onClick, ariaLabelBack = '戻る', ariaLabelQuestion = 'ヘルプ' }) => {
  if (!icon) {
    return <div className="inline-block size-10" aria-hidden />
  }

  const label = icon === 'Back' ? ariaLabelBack : ariaLabelQuestion

  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      className="relative inline-block size-10"
    >
      <img
        src={bgVector}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 block size-10 max-w-none"
      />
      <div className="absolute left-2 top-2 overflow-clip size-6">
        <IconImg name={icon} />
      </div>
    </button>
  )
}

export interface HeaderProps {
  title?: string
  leftIcon?: HeaderIcon
  rightIcon?: HeaderIcon
  onLeftClick?: () => void
  onRightClick?: () => void
  leftSlot?: React.ReactNode
  rightSlot?: React.ReactNode
  titleClassName?: string
  className?: string
}

export const Header: React.FC<HeaderProps> = ({
  title = 'タイトル',
  leftIcon = 'Back',
  rightIcon = 'Question',
  onLeftClick,
  onRightClick,
  leftSlot,
  rightSlot,
  titleClassName,
  className,
}) => {
  const baseTitleClass = 'select-none text-[20px] font-bold leading-none'
  const resolvedTitleClass = `${baseTitleClass} ${titleClassName ?? 'text-zinc-900'}`.trim()
  const baseHeaderClass = 'flex h-16 w-full items-center justify-between px-4'
  const resolvedHeaderClass = `${baseHeaderClass} ${className ?? ''}`.trim()

  return (
    <div className={resolvedHeaderClass}>
      <div className="inline-flex h-10 w-10 items-center justify-center">
        {leftSlot ? leftSlot : <IconButton icon={leftIcon} onClick={onLeftClick} />}
      </div>
      <div className={resolvedTitleClass}>{title}</div>
      <div className="inline-flex h-10 w-10 items-center justify-center">
        {rightSlot ? rightSlot : <IconButton icon={rightIcon} onClick={onRightClick} />}
      </div>
    </div>
  )
}

export default Header
